export { default } from "./PersonSearchResults";



// WEBPACK FOOTER //
// ./src/components/client-search/PersonSearchResults/index.js